import { formatCurrency } from '@asn/formatters';

import { Injectable } from '@angular/core';

/**
 * @deprecated in favor of `currencyFormatter` in [`@asn/formatters`](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/formatters--docs). To be removed with the Angular 23 migration.
 */
@Injectable({
    providedIn: 'root'
})
export class ApCurrencyService {
    private readonly locale = 'nl-NL';

    public transform(
        value: number,
        currencyCode = 'EUR',
        display: 'code' | 'symbol' | 'symbol-narrow' = 'symbol',
        digits: string = null, // uses defaults for loaded locale file
        locale: string = this.locale
    ): string | null {
        return formatCurrency(value, currencyCode, display, digits, locale);
    }
}
